import { DialogContent, DialogTitle, IconButton, Stack, Icon, Divider, Dialog } from "@tm/components"
import { useState } from "react"

type Props = {
    children: React.ReactNode
    open: boolean
    title: string
    icon: string
    onClose: () => void
}

export function ContentDialog(props: Props) {
    const { children, open, title, icon, onClose } = props
    const [fullscreen, setFullScreen] = useState(false)

    return (
        <Dialog
            className="form-confirmation"
            open={open}
            PaperProps={!fullscreen ? { sx: { height: "70vh", width: "65%" } } : {}}
            maxWidth={false}
            onOutsideClick={onClose}
            fullScreen={fullscreen}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center" padding={1}>
                <Stack direction="row" alignItems="left" gap={1}>
                    <Icon name={icon} size="large" />
                    <DialogTitle fontSize="1.25rem" sx={{ padding: 0 }}>
                        {title}
                    </DialogTitle>
                </Stack>
                <Stack direction="row" alignItems="right" gap={1}>
                    <IconButton onClick={() => setFullScreen((prev) => !prev)}>
                        <Icon name={!fullscreen ? "fullscreen" : "fullscreen-exit"} />
                    </IconButton>
                    <IconButton onClick={onClose}>
                        <Icon name="close" />
                    </IconButton>
                </Stack>
            </Stack>
            <DialogContent sx={{ height: "90%", padding: 0 }}>
                <Divider />
                {children}
            </DialogContent>
        </Dialog>
    )
}
